import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiEye, FiHeart, FiMousePointer, FiUsers, FiFileText } = FiIcons;

const SocialMediaPerformance = ({ client, data }) => {
  const [selectedPlatform, setSelectedPlatform] = useState('linkedin');
  
  const safeData = data || { platforms: {} };
  const platformsData = safeData.platforms || {};

  const platforms = [
    { id: 'linkedin', name: 'LinkedIn', color: '#0077B5' },
    { id: 'facebook', name: 'Facebook', color: '#1877F2' },
    { id: 'instagram', name: 'Instagram', color: '#E4405F' },
    { id: 'twitter', name: 'X/Twitter', color: '#000000' },
    { id: 'tiktok', name: 'TikTok', color: '#000000' }
  ];

  const currentData = platformsData[selectedPlatform] || { impressions: 0, engagement: 0, clicks: 0, followers: 0, posts: 0 };

  const metrics = [
    { title: 'Impressions', value: currentData.impressions.toLocaleString(), icon: FiEye, color: 'text-blue-600' },
    { title: 'Engagement', value: currentData.engagement.toLocaleString(), icon: FiHeart, color: 'text-red-600' },
    { title: 'Clicks', value: currentData.clicks.toLocaleString(), icon: FiMousePointer, color: 'text-green-600' },
    { title: 'Followers', value: currentData.followers.toLocaleString(), icon: FiUsers, color: 'text-purple-600' },
    { title: 'Posts', value: currentData.posts.toString(), icon: FiFileText, color: 'text-orange-600' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Social Media Performance</h2>
        <p className="text-gray-600">Metrics across platforms</p>
      </div>

      <div className="flex flex-wrap gap-3">
        {platforms.map((platform) => (
          <motion.button
            key={platform.id}
            onClick={() => setSelectedPlatform(platform.id)}
            className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
              selectedPlatform === platform.id
                ? 'text-white shadow-md'
                : 'bg-white text-gray-700 border border-gray-200 hover:border-gray-300'
            }`}
            style={{ backgroundColor: selectedPlatform === platform.id ? platform.color : undefined }}
          >
            {platform.name}
          </motion.button>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center justify-center mb-4">
              <div className={`w-10 h-10 rounded-lg bg-opacity-10 flex items-center justify-center ${metric.color.replace('text-', 'bg-')}`}>
                <SafeIcon icon={metric.icon} className={`text-lg ${metric.color}`} />
              </div>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-800 mb-1">{metric.value}</h3>
              <p className="text-sm text-gray-600">{metric.title}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaPerformance;